(function ($, ko) {

    ko.bindingHandlers.chartExpensesYearToDateDonut = {
        update: function (element, valueAccessor) {
            var lastYear = ko.unwrap(valueAccessor());
            if (!lastYear) return;

            //chart settings
            var chartData = {
                element: element,
                colorScheme: 'expenses-year-to-date',
                dataArr: [
                    { "label": $.cdh.languageConstant.getConstant('field.reimbursed-from-accounts'), "value": lastYear.ReimbursedFromAccounts },
                    { "label": $.cdh.languageConstant.getConstant('field.paid-out-of-pocket'), "value": lastYear.PaidOutOfPocket },
                    { "label": $.cdh.languageConstant.getConstant('field.my-remaining'), "value": lastYear.RemainingResponsibility }
                ]
            };
            //create the chart
            $.cdh.charts.bindDonutChart(chartData);
        }
    };

    ko.bindingHandlers.chartExpensesYearToDateColorRemaining = {
        update: function (element, valueAccessor) {
            const color = $.cdh.brandData.ChartYearToDateSpendingRemainingColor;
            $(element).css('background', color);

            const pattern = $.cdh.helper.makeTagPattern(color, '0');
            const svg = $.cdh.helper.makePatternSvg(pattern);
            element.innerHTML += svg;
        }
    }

    ko.bindingHandlers.chartExpensesYearToDateColorReimbursed = {
        update: function (element, valueAccessor) {
            const color = $.cdh.brandData.ChartYearToDateSpendingReimbursedColor;
            $(element).css('background', color);

            const pattern = $.cdh.helper.makeTagPattern(color, '2');
            const svg = $.cdh.helper.makePatternSvg(pattern);
            element.innerHTML += svg;
        }
    }

    ko.bindingHandlers.chartExpensesYearToDateColorPaid = {
        update: function (element, valueAccessor) {
            const color = $.cdh.brandData.ChartYearToDateSpendingPaidColor;
            $(element).css('background', color);

            const pattern = $.cdh.helper.makeTagPattern(color, '1');
            const svg = $.cdh.helper.makePatternSvg(pattern);
            element.innerHTML += svg;
        }
    }

    ko.bindingHandlers.chartExpensesTotalResponsibility = {
        update: function (element, valueAccessor) {
            // expects that summaries are ordered by year
            var summaries = ko.unwrap(valueAccessor());
            if (!summaries) return;

            if ((summaries.slice(-1)[0] || {}).ExpensesYear === new Date().getFullYear())
                summaries = summaries.slice(0, -1);

            if (summaries.length == 0) return;

            function getTotalForStacked(itemIndex) {
                var totalValue = summaries[itemIndex].RemainingResponsibility + summaries[itemIndex].ReimbursedFromAccounts + summaries[itemIndex].PaidOutOfPocket;
                totalValue = Math.round(totalValue * 100) / 100;
                return totalValue;
            }

            function getMaxValueAxis() {
                var i, count = 0, max = 0, current_value, result;
                for (i = 0 ; i < summaries.length; i++) {
                    current_value = summaries[i].RemainingResponsibility + summaries[i].ReimbursedFromAccounts + summaries[i].PaidOutOfPocket;
                    if (current_value > max) { max = current_value; }
                    ++count;
                }
                try {
                    result = max + (max / count);
                } catch(e) {
                    result = max;
                }
                return result;
            }

            //chart settings
            var chartData = {
                element: element,
                colorScheme: 'expenses-total-responsibility',
                columnsMaxWidth: 70,
                columnsMinWidth: 70,
                xAxis: {
                    dataField: 'ExpensesYear', unitInterval: 1, axisSize: 'auto', gridLines: { visible: false },
                    tickMarks: { visible: false }
                },
                valueAxis: {
                    title: { text: '' },
                    unitInterval: 0,
                    labels: { step: 1, horizontalAlignment: 'right', formatSettings: { prefix: '$', decimalPlaces: 2 } },
                    tickMarks: { color: '#ebebeb' },
                    gridLines: { color: '#ebebeb' },
                    maxValue: getMaxValueAxis()
                },
                series: [
                    {
                        dataField: 'PaidOutOfPocket',
                        displayText: $.cdh.languageConstant.getConstant('field.paid-out-of-pocket'),
                        formatSettings: { prefix: '$', decimalPlaces: 2 },
                        labels: { visible: false },
                        toolTipFormatFunction: function (value, itemIndex, serieIndex, groupIndex) {
                            return serieIndex.displayText + ': $' + value;
                        }
                    },
                    {
                        dataField: 'ReimbursedFromAccounts',
                        displayText: $.cdh.languageConstant.getConstant('field.reimbursed-from-accounts'),
                        formatSettings: { prefix: '$', decimalPlaces: 2 },
                        labels: { visible: false },
                        toolTipFormatFunction: function (value, itemIndex, serieIndex, groupIndex) {
                            return serieIndex.displayText + ': $' + value;
                        }
                    },
                    {
                        dataField: 'RemainingResponsibility',
                        displayText: $.cdh.languageConstant.getConstant('field.my-remaining'),
                        formatSettings: { prefix: '$', decimalPlaces: 2 },
                        formatFunction: function (value, itemIndex, serieIndex, groupIndex) {
                            return '$' + getTotalForStacked(itemIndex);
                        },
                        labels: { visible: true, offset: { x: 0, y: -30 }, verticalAlignment: 'top', class: 'account-contribution-text' },
                        toolTipFormatFunction: function (value, itemIndex, serieIndex, groupIndex) {
                            return serieIndex.displayText + ': $' + value;
                        }
                    }
                ],
                dataArr: summaries
            };
            // if ($.cdh.isMobile) {
            //     chartData.columnsMaxWidth = 30;
            //     chartData.columnsMinWidth = 30;
            // }
            chartData.columnsMaxWidth = 130;
            chartData.columnsMinWidth = 20;
            //create the chart
            $.cdh.charts.bindStackedColumnChart(chartData);
        }
    };

    ko.bindingHandlers.chartExpensesTotalResponsibilityColorRemaining = {
        update: function (element, valueAccessor) {
            const color = $.cdh.brandData.ChartTotalResponsibilityRemainingColor;
            $(element).css('background', color);

            const pattern = $.cdh.helper.makeTagPattern(color, '2');
            const svg = $.cdh.helper.makePatternSvg(pattern);
            element.innerHTML += svg;
        }
    }

    ko.bindingHandlers.chartExpensesTotalResponsibilityColorPaid = {
        update: function (element, valueAccessor) {
            const color = $.cdh.brandData.ChartTotalResponsibilityReimbursedColor;
            $(element).css('background', color);

            const pattern = $.cdh.helper.makeTagPattern(color, '0');
            const svg = $.cdh.helper.makePatternSvg(pattern);
            element.innerHTML += svg;
        }
    }

    ko.bindingHandlers.chartExpensesTotalResponsibilityColorReimbursed = {
        update: function (element, valueAccessor) {
            const color = $.cdh.brandData.ChartTotalResponsibilityPaidColor;
            $(element).css('background', color);

            const pattern = $.cdh.helper.makeTagPattern(color, '1');
            const svg = $.cdh.helper.makePatternSvg(pattern);
            element.innerHTML += svg;
        }
    }
})(jQuery, ko);